export const ASSET_AVAILABLE = 'AVAILABLE';
export const ASSET_MUST_RUN = 'MUST_RUN';
export const ASSET_UNAVAILABLE = 'UNAVAILABLE';
export const ASSET_ERROR = 'ERROR';
